import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Layout from "../../../component/layout";

import MeterInfoTab from "./view_power_meter_tabs/meterInfoTab";
import AssignedCustomersTab from "./view_power_meter_tabs/assignedCustomersTab";
import ConsumptionReadingsTab from "./view_power_meter_tabs/consumptionReadingsTab";
import ConsumptionGraphTab from "./view_power_meter_tabs/consumptionGraphTab";
import OnOffLogsTab from "./view_power_meter_tabs/onOffLogsTab";
import TransactionHistoryTab from "./view_power_meter_tabs/transactionHistoryTab";
import AutoOnOffScheduleTab from "./view_power_meter_tabs/autoOnOffScheduleTab";

const ViewPowerMeter = () => {
  const [activeTab, setActiveTab] = useState("meter-info");
  const location = useLocation();

  const previousTab = location.state?.previousTab || "smart-power-meters";

  const backUrl = `/facility/utility_management/meter_management/power_meters?tab=${previousTab}`;

  const tabComponents = {
    "meter-info": MeterInfoTab,
    "assigned-customers": AssignedCustomersTab,
    "consumption-readings": ConsumptionReadingsTab,
    "consumption-graph": ConsumptionGraphTab,
    "on-off-logs": OnOffLogsTab,
    "transaction-history": TransactionHistoryTab,
    "auto-schedule": AutoOnOffScheduleTab,
  };

  const TabComponent = tabComponents[activeTab] || MeterInfoTab;

  const tabs = [
    {
      id: "meter-info",
      label: "Meter Info",
      icon: "ti-dashboard",
    },
    {
      id: "assigned-customers",
      label: "Assigned Customers",
      icon: "ti-users",
    },
    {
      id: "consumption-readings",
      label: "Consumption Readings",
      icon: "ti-list-numbers",
    },
    {
      id: "consumption-graph",
      label: "Consumption Graph",
      icon: "ti-chart-line",
    },
    {
      id: "on-off-logs",
      label: "On/Off Logs",
      icon: "ti-text-wrap-disabled",
    },
    {
      id: "transaction-history",
      label: "Transaction History",
      icon: "ti-cash",
    },
    {
      id: "auto-schedule",
      label: "Auto On/Off Schedule",
      icon: "ti-calendar-time",
    },
  ];

  return (
    <Layout>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <ul className="breadcrumb mb-3">
                <li className="breadcrumb-item">
                  <Link to="/facility/">Dashboard</Link>
                </li>

                <li className="breadcrumb-item">
                  <Link to="/facility/utility_management/meter_management/">
                    Power Meter
                  </Link>
                </li>

                <li className="breadcrumb-item active">
                  <span>View Power Meter</span>
                </li>
              </ul>

              <div className="card">
                <div className="card-header">
                  <Link to={backUrl}>
                    <i className="ti ti-arrow-left me-1"></i>
                    Back
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body py-0">
              <ul
                className="nav nav-tabs profile-tabs"
                id="myTab"
                role="tablist"
              >
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.id} role="presentation">
                    <button
                      className={`nav-link ${
                        activeTab === tab.id ? "active" : ""
                      }`}
                      id={`${tab.id}-tab`}
                      type="button"
                      role="tab"
                      aria-selected={activeTab === tab.id}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <i className={`ti ${tab.icon} me-2`}></i>
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="tab-content">
            <TabComponent />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ViewPowerMeter;
